import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Sparkline } from '../charts/Sparkline.jsx';

export function Card({ title, actions, children, className }) {
  return (
    <section className={clsx('card', className)}>
      {(title || actions) && (
        <header className="card-header">
          {title && <h2 className="card-title">{title}</h2>}
          {actions}
        </header>
      )}
      {children}
    </section>
  );
}

/**
 * @param {{
 *   label: string,
 *   value: React.ReactNode,
 *   trend?: React.ReactNode,
 *   trendVariant?: string,
 *   delta?: { value: string, direction: 'up'|'down', variant: 'success'|'danger'|'muted' },
 *   spark?: number[],
 *   to?: string,
 * }} props
 * With `to`, the whole tile becomes a link to the matching page (drill-down).
 */
export function MetricCard({ label, value, trend, trendVariant = 'muted', delta, spark, to }) {
  const body = (
    <>
      <span className="metric-label">{label}{to && <span className="metric-link-arrow" aria-hidden="true">→</span>}</span>
      <span className="metric-value">{value}</span>
      {delta && (
        <span className={`metric-delta ${delta.variant || 'muted'}`}>
          <span aria-hidden="true">{delta.direction === 'down' ? '▼' : '▲'}</span> {delta.value}
        </span>
      )}
      {trend && (
        <span className={`metric-trend ${trendVariant}`}>{trend}</span>
      )}
      {spark && spark.length >= 2 && <Sparkline data={spark} />}
    </>
  );
  if (to) {
    return <Link to={to} className="metric-card metric-card-link">{body}</Link>;
  }
  return <article className="metric-card">{body}</article>;
}
